import React, { useState, useEffect } from 'react';
import { Container, Spinner, Alert, Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';  // Import useParams to access URL parameters
import { BASE_URL } from '../constants';
import Layout from './Layout';
const NotificationComponent = () => {
  const { userId } = useParams();  // Get the userId from URL params
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await fetch(`${BASE_URL}/refugees/auto-checkout/user/${userId}`);
        const data = await response.json();

        if (data?.refugee) {
          setNotification(data.refugee);
        } else {
          setNotification(null);  // If no refugee data is found
        }
        setError(null);
      } catch (err) {
        console.error('Error fetching notification details:', err);
        setError('Failed to fetch notifications');
      } finally {
        setLoading(false);
      }
    };

    fetchNotification();
  }, [userId]);  // Re-run this effect when userId changes

  return (
    <Layout>
    <Container className="py-4 px-0"> 
      {loading && (
      <div className="text-center">
      <Spinner animation="border" variant="primary" />
      </div>
        )}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* If no notification is found */}
      {!notification && !loading && !error && (
        <Alert variant="info">No notification data available.</Alert>
      )}

      {/* If notification data is found */}
      {notification && (
     
  <div className="row justify-content-center">
      <div className="col-12 col-md-8 col-lg-7">
          <Card className="shadow-lg border-0 rounded">
              <Card.Body className="p-6">
        <h4 className="mb-4 text-center text-primary">Auto-Checkout</h4>
        
            <Card.Title>{notification.name}</Card.Title>
            <Card.Text>
              <strong>Check-In Time:</strong> {new Date(notification.checkInTime).toLocaleString()}
            </Card.Text>
            <Card.Text>
              <strong>Check-Out Time:</strong> {new Date(notification.checkOutTime).toLocaleString()}
            </Card.Text>
            </Card.Body>
                </Card>
            </div>
        </div>
   
      )}
      </ Container>
      </Layout>
  );
};

export default NotificationComponent;
